// Tvar odpovědí API podle docs/SPEC.md část 5.
import { z } from 'zod'

export const API_ERROR_CODES = [
  'unauthorized',
  'forbidden',
  'not_found',
  'validation',
  'conflict',
  'rate_limited',
  'app_outdated',
  'internal',
] as const
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES)
export type ApiErrorCode = z.infer<typeof apiErrorCodeSchema>

export const HTTP_STATUS_BY_CODE: Record<ApiErrorCode, number> = {
  unauthorized: 401,
  forbidden: 403,
  not_found: 404,
  validation: 422,
  conflict: 409,
  rate_limited: 429,
  app_outdated: 426,
  internal: 500,
}

export interface ApiErrorBody {
  error: {
    code: ApiErrorCode
    message: string
    details?: unknown
  }
}

export interface ApiList<T> {
  data: T[]
  nextCursor: string | null
}

export const listQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  q: z.string().trim().max(200).optional(),
})
export type ListQuery = z.infer<typeof listQuerySchema>

export const healthSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  db: z.boolean(),
  queue: z.boolean(),
  time: z.string(),
})
export type Health = z.infer<typeof healthSchema>

export const APP_VERSION_HEADER = 'X-App-Version'
export const API_PREFIX = '/v1'
